import { gql } from 'graphql-request'

export const QueryBlockHeroDual = gql`
  fragment FragmentBlockHeroDual on BlockHeroDualModelRecord {
          __typename
          id
          preface
          title
          homepage
          description {
            value
          }
          primaryAction {
            ...FragmentNavigationItem
          }
          secondaryAction {
            ...FragmentNavigationItem
          }
          image {
            mimeType
            url
            title
            height
            width
            responsiveImage {
              ...responsiveImageFragment
            }
          }
          wistiaVideo {
            ...QueryVideo
          }
          includesSearch
          logo {
            id
            name
            svgIcon {
              title
              alt
              url
            }
          }
        }
`

export const BlockHeroDual = {
  __typename: 'BlockHeroDual',
  fragmentName: 'FragmentBlockHeroDual',
  fragmentQuery: QueryBlockHeroDual,
  fragments: ['FragmentNavigationItem', 'QueryVideo']
}
